import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import SearchAndFilter from "../../SearchAndFilter/SearchAndFilter";
import { PurchaseOrderDetails } from "../PurchaseOrderDetails/PurchaseOrderDetails";
import { PurchaseOrderList } from "../PurchaseOrderList/PurchaseOrderList";
import styles from "./purchaseOrder.module.css";
import { PRODUCT } from "../../../Utils/variables";
import { ToastContainer } from "react-toastify";
export const PurchaseOrders = () => {
  const [detailId, setDetailId] = useState();
  const [communityId, setCommunityId] = useState()
  const [getFilterData, setgetFilterData] = useState({});
  const [searched, setSearched] = useState("");
  const FilterData = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend
  ) => {
    let obj = {
      Communities,
      manageBy,
      closingOnstart,
      closingOnend,
      postedOnstart,
      postedOnend,
    };
    setgetFilterData(obj);
  };
  const handleDetail = (id, commId) => {
    setDetailId(id);
    setCommunityId(commId)
  };
  const searchFucntion = (serchQueryu) => {
    setSearched(serchQueryu);
  };
  document.title = PRODUCT + " - Purchase Orders";

  return (
    <div className="routingSubContainer">
      <Header title={"Purchase Orders"} />
      <SearchAndFilter
        FilterData={FilterData}
        closefilter={false}
        searchFucntion={searchFucntion}
      />
      <div className={styles.mainDivPO}>
        <div className={styles.leftDivPO}>
          <PurchaseOrderList
            handleDetail={handleDetail}
            getFilterData={getFilterData}
            searched={searched}
          />
        </div>
        <div className={styles.rightDivPO}>
          <PurchaseOrderDetails
            detailId={detailId}
            communityId={communityId}
            getFilterData={getFilterData}
          />
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};
